export const MAX_API_RESPONSE_WAIT_TIME = 1000 * 60 * 15 * 2; // 30 minutes
export const MAX_API_RESPONSE_WAIT_TIME_5 = 5 * 60 * 1000; // 5 minutes
